
import React from 'react'
import { Link } from 'react-router-dom';
import LogoImage from "../assets/images/Group5502-svg.svg";

function Logo({width=75, height=50}) {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  return (
   <div>
      <Link to={userInfo ? userInfo.userType == 'user' ? '/userDashboard': '/home' : '/prelogin'}>
        <img style={{borderRadius: '5px'}} src={LogoImage} width={width} height={height}/>
      </Link>
    </div> 
  )
}

export default Logo